import { AggregateOffer, ImageObject, Product, WithContext } from "schema-dts";
import Car from "@shared/lib/interfaces/car.interface";
import { CatalogCarSchemaParams } from "@shared/lib/utils/getCatalogCarSchema/types";

export const getCatalogCarSchema = ({
    canonicalUrl,
    title,
    description,
    brandName,
    offersData,
    totalOffers
}: CatalogCarSchemaParams): WithContext<Product> => {
    const imagesForCarSchema = offersData
        .map((offer: Car) => {
            const smallImage = offer.imagesList?.[0]?.small;
            const bigImage = offer.imagesList?.[0]?.big;

            return smallImage && smallImage !== "" ? smallImage : bigImage;
        })
        .filter(Boolean);

    const imageObjects: ImageObject[] = imagesForCarSchema.map((image) => ({
        "@type": "ImageObject",
        image: image,
        contentUrl: image
    }));

    const offersInfo: AggregateOffer = {
        "@type": "AggregateOffer",
        priceCurrency: "USD",
        lowPrice: 1,
        offerCount: totalOffers
    };

    const schema: WithContext<Product> = {
        "@context": "https://schema.org",
        "@type": "Product",
        additionalType: "Car",
        url: canonicalUrl,
        name: title,
        description: description,
        brand: {
            "@type": "Brand",
            name: brandName
        },
        offers: offersInfo
    };
    if (imageObjects.length > 0) {
        schema.image = imageObjects;
    }
    return schema;
};